<template>
	<div :class="$style.list" v-if="algoliaKey">
    <p><button v-on:click="reindex">Reindex accounts</button></p>
    <ais-index app-id="HHG05IP3IE" :api-key="algoliaKey" :index-name="algoliaIndex">
      <ais-search-box></ais-search-box>
      <ul>
        <ais-results>
          <template slot-scope="{ result }">
              <li v-on:click="selectItem(result.objectID)">{{ result.email }}</li>
          </template>
        </ais-results>
      </ul>
    </ais-index>
  </div>
</template>

<script>
import algolia from '../../../api/algolia'
import config from '../../../api/config'

export default {
  name: 'users',
  data () {
    return {
      query: '',
      algoliaKey: '',
      algoliaIndex: config.ALGOLIA_ACCOUNT_INDEX
    }
  },
  methods: {
    selectItem (id) {
      this.$router.push({path: `/users/${id}`})
    },
    reindex () {
      if (confirm('Reindex user accounts?')) {
        algolia
          .reindex()
          .then(() => {
            this.$toasted.show('Accounts have been sucessfully reindexed', {
              duration: 3000,
              className: 'toasty'
            })
          }).catch((err) => {
            console.log('Reindex error:', err)
            this.$toasted.show('Error: unable to reindex accounts', {
              duration: 3000,
              className: 'toasty-error'
            })
          })
      }
    }
  },
  mounted () {
    var vc = this
    algolia.getKey()
      .then(function (data) {
        vc.algoliaKey = data
      })
  }
}
</script>

<style lang="scss" module>
  .list {
    ul {
      padding: 0;
      list-style-type: none;
      li {
        display: block;
        padding: 3px 6px;
        margin-bottom: 3px;
        cursor: pointer;
      }
    }
    .search {
      display: block;
      width: 100%;
      padding: 0.7em;
      font-size: 1em;
      border: 1px solid #DDD;
      margin-bottom: .5em;
      border-radius: 3px;
      box-shadow: inset 0 1px 3px rgba(0,0,0,0.06);
      outline: none;

      &:focus {
        border-color: #2196F3;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Users/list/index.vue